"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLegalRequestSuccessAction = exports.updateLegalRequestFailAction = exports.updateLegalRequestAction = exports.updateIdentificationDataRequestSuccessAction = exports.updateIdentificationDataRequestFailAction = exports.updateIdentificationDataRequestAction = exports.setPreloadingProcess = exports.selectUsers = exports.selectUser = exports.selectPreloadingProcess = exports.selectInProcess = exports.selectIdentificationInProcess = exports.selectIdentificationData = exports.selectError = exports.resetStateAction = exports.removeUserRequestSuccessAction = exports.removeUserRequestFailAction = exports.removeUserRequestAction = exports.reducer = exports.name = exports.initConfirmEmailDataRequestSuccessAction = exports.initConfirmEmailDataRequestFailAction = exports.initConfirmEmailDataRequestAction = exports.getUsersRequestSuccessAction = exports.getUsersRequestFailAction = exports.getUsersRequestAction = exports.getUserRequestSuccessAction = exports.getUserRequestFailAction = exports.getUserRequestAction = exports.getOptionsRequestSuccessAction = exports.getOptionsRequestFailAction = exports.getOptionsRequestAction = exports.getIdentificationDataRequestSuccessAction = exports.getIdentificationDataRequestFailAction = exports.getIdentificationDataRequestAction = exports.createUserRequestAction = exports.confirmEmailRequestSuccessAction = exports.confirmEmailRequestFailAction = exports.confirmEmailRequestAction = exports.changeUserEmailRequestSuccessAction = exports.changeUserEmailRequestFailAction = exports.changeUserEmailRequestAction = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'module/options';
var INITIAL_STATE = {
  inProcess: false,
  user: {
    userName: '',
    email: '',
    name: '',
    emailConfirmed: false
  },
  users: [],
  error: null,
  identification: null,
  identificationInProcess: false
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: INITIAL_STATE,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['inProcess'] = false;
      state['user'] = {
        userName: '',
        email: '',
        name: '',
        emailConfirmed: false
      };
      state['users'] = [];
      state['error'] = null;
      state['identification'] = null;
      state['identificationInProcess'] = false;
    },
    setPreloadingProcess: function setPreloadingProcess(state, _ref) {
      var payload = _ref.payload;
      state['preloadingProcess'] = payload;
    },
    createUserRequestAction: function createUserRequestAction(state, _ref2) {
      var payload = _ref2.payload;
      state['users'] = [].concat((0, _toConsumableArray2["default"])(state['users']), [payload]);
    },
    getUsersRequestAction: function getUsersRequestAction(state) {
      state['inProcess'] = true;
    },
    getUsersRequestFailAction: function getUsersRequestFailAction(state) {
      state['inProcess'] = false;
    },
    getUsersRequestSuccessAction: function getUsersRequestSuccessAction(state, _ref3) {
      var payload = _ref3.payload;
      state['users'] = payload;
      state['inProcess'] = false;
    },
    removeUserRequestAction: function removeUserRequestAction(state) {
      state['inProcess'] = true;
    },
    removeUserRequestFailAction: function removeUserRequestFailAction(state) {
      state['inProcess'] = false;
    },
    removeUserRequestSuccessAction: function removeUserRequestSuccessAction(state, _ref4) {
      var payload = _ref4.payload;
      state['users'] = state['users'].filter(function (user) {
        return user['id'] !== payload['id'];
      });
      state['inProcess'] = false;
    },
    getOptionsRequestAction: function getOptionsRequestAction(state) {},
    getOptionsRequestFailAction: function getOptionsRequestFailAction(state) {},
    getOptionsRequestSuccessAction: function getOptionsRequestSuccessAction(state, _ref5) {
      var payload = _ref5.payload;
      state['user'] = (0, _objectSpread2["default"])({}, payload);
    },
    getIdentificationDataRequestAction: function getIdentificationDataRequestAction(state) {
      state['identificationInProcess'] = true;
    },
    getIdentificationDataRequestFailAction: function getIdentificationDataRequestFailAction(state) {
      state['identificationInProcess'] = false;
    },
    getIdentificationDataRequestSuccessAction: function getIdentificationDataRequestSuccessAction(state, _ref6) {
      var payload = _ref6.payload;
      state['identificationInProcess'] = false;
      state['identification'] = payload;
    },
    changeUserEmailRequestAction: function changeUserEmailRequestAction(state) {
      state['inProcess'] = true;
    },
    changeUserEmailRequestFailAction: function changeUserEmailRequestFailAction(state) {
      state['inProcess'] = false;
    },
    changeUserEmailRequestSuccessAction: function changeUserEmailRequestSuccessAction(state, _ref7) {
      var payload = _ref7.payload;
      state['user'] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state['user']), payload);
      state['inProcess'] = false;
    },
    initConfirmEmailDataRequestAction: function initConfirmEmailDataRequestAction(state) {
      state['inProcess'] = true;
    },
    initConfirmEmailDataRequestFailAction: function initConfirmEmailDataRequestFailAction(state) {
      state['inProcess'] = false;
    },
    initConfirmEmailDataRequestSuccessAction: function initConfirmEmailDataRequestSuccessAction(state) {
      state['inProcess'] = false;
    },
    confirmEmailRequestAction: function confirmEmailRequestAction(state) {
      state['inProcess'] = true;
    },
    confirmEmailRequestFailAction: function confirmEmailRequestFailAction(state) {
      state['inProcess'] = false;
    },
    confirmEmailRequestSuccessAction: function confirmEmailRequestSuccessAction(state, _ref8) {
      var payload = _ref8.payload;
      state['inProcess'] = false;
      state['user'] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state['user']), payload), {}, {
        emailConfirmed: true
      });
    },
    updateIdentificationDataRequestAction: function updateIdentificationDataRequestAction(state) {
      state['identificationInProcess'] = true;
    },
    updateIdentificationDataRequestFailAction: function updateIdentificationDataRequestFailAction(state) {
      state['identificationInProcess'] = false;
    },
    updateIdentificationDataRequestSuccessAction: function updateIdentificationDataRequestSuccessAction(state, _ref9) {
      var payload = _ref9.payload;
      state['identificationInProcess'] = false;
      state['identification'] = payload;
    },
    updateLegalRequestAction: function updateLegalRequestAction(state) {
      state['inProcess'] = true;
    },
    updateLegalRequestSuccessAction: function updateLegalRequestSuccessAction(state) {
      state['inProcess'] = false;
    },
    updateLegalRequestFailAction: function updateLegalRequestFailAction(state) {
      state['inProcess'] = false;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase((0, _toolkit.createAction)('widget/button/updateUserRequestSuccessAction'), function (state, _ref0) {
      var payload = _ref0.payload;
      state['users'] = state['users'].map(function (item) {
        if (item['id'] === payload['id']) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, item), payload);
        }

        return item;
      });
    });
  }
});
var _slice$actions = slice['actions'],
    resetStateAction = _slice$actions.resetStateAction,
    setPreloadingProcess = _slice$actions.setPreloadingProcess,
    createUserRequestAction = _slice$actions.createUserRequestAction,
    getUsersRequestAction = _slice$actions.getUsersRequestAction,
    getUsersRequestFailAction = _slice$actions.getUsersRequestFailAction,
    getUsersRequestSuccessAction = _slice$actions.getUsersRequestSuccessAction,
    getUserRequestAction = _slice$actions.getUserRequestAction,
    getUserRequestFailAction = _slice$actions.getUserRequestFailAction,
    getUserRequestSuccessAction = _slice$actions.getUserRequestSuccessAction,
    removeUserRequestAction = _slice$actions.removeUserRequestAction,
    removeUserRequestFailAction = _slice$actions.removeUserRequestFailAction,
    removeUserRequestSuccessAction = _slice$actions.removeUserRequestSuccessAction,
    getOptionsRequestAction = _slice$actions.getOptionsRequestAction,
    getOptionsRequestFailAction = _slice$actions.getOptionsRequestFailAction,
    getOptionsRequestSuccessAction = _slice$actions.getOptionsRequestSuccessAction,
    changeUserEmailRequestAction = _slice$actions.changeUserEmailRequestAction,
    changeUserEmailRequestFailAction = _slice$actions.changeUserEmailRequestFailAction,
    changeUserEmailRequestSuccessAction = _slice$actions.changeUserEmailRequestSuccessAction,
    initConfirmEmailDataRequestAction = _slice$actions.initConfirmEmailDataRequestAction,
    initConfirmEmailDataRequestFailAction = _slice$actions.initConfirmEmailDataRequestFailAction,
    initConfirmEmailDataRequestSuccessAction = _slice$actions.initConfirmEmailDataRequestSuccessAction,
    confirmEmailRequestAction = _slice$actions.confirmEmailRequestAction,
    confirmEmailRequestFailAction = _slice$actions.confirmEmailRequestFailAction,
    confirmEmailRequestSuccessAction = _slice$actions.confirmEmailRequestSuccessAction,
    getIdentificationDataRequestAction = _slice$actions.getIdentificationDataRequestAction,
    getIdentificationDataRequestFailAction = _slice$actions.getIdentificationDataRequestFailAction,
    getIdentificationDataRequestSuccessAction = _slice$actions.getIdentificationDataRequestSuccessAction,
    updateIdentificationDataRequestAction = _slice$actions.updateIdentificationDataRequestAction,
    updateIdentificationDataRequestFailAction = _slice$actions.updateIdentificationDataRequestFailAction,
    updateIdentificationDataRequestSuccessAction = _slice$actions.updateIdentificationDataRequestSuccessAction,
    updateLegalRequestAction = _slice$actions.updateLegalRequestAction,
    updateLegalRequestSuccessAction = _slice$actions.updateLegalRequestSuccessAction,
    updateLegalRequestFailAction = _slice$actions.updateLegalRequestFailAction;
exports.updateLegalRequestFailAction = updateLegalRequestFailAction;
exports.updateLegalRequestSuccessAction = updateLegalRequestSuccessAction;
exports.updateLegalRequestAction = updateLegalRequestAction;
exports.updateIdentificationDataRequestSuccessAction = updateIdentificationDataRequestSuccessAction;
exports.updateIdentificationDataRequestFailAction = updateIdentificationDataRequestFailAction;
exports.updateIdentificationDataRequestAction = updateIdentificationDataRequestAction;
exports.getIdentificationDataRequestSuccessAction = getIdentificationDataRequestSuccessAction;
exports.getIdentificationDataRequestFailAction = getIdentificationDataRequestFailAction;
exports.getIdentificationDataRequestAction = getIdentificationDataRequestAction;
exports.confirmEmailRequestSuccessAction = confirmEmailRequestSuccessAction;
exports.confirmEmailRequestFailAction = confirmEmailRequestFailAction;
exports.confirmEmailRequestAction = confirmEmailRequestAction;
exports.initConfirmEmailDataRequestSuccessAction = initConfirmEmailDataRequestSuccessAction;
exports.initConfirmEmailDataRequestFailAction = initConfirmEmailDataRequestFailAction;
exports.initConfirmEmailDataRequestAction = initConfirmEmailDataRequestAction;
exports.changeUserEmailRequestSuccessAction = changeUserEmailRequestSuccessAction;
exports.changeUserEmailRequestFailAction = changeUserEmailRequestFailAction;
exports.changeUserEmailRequestAction = changeUserEmailRequestAction;
exports.getOptionsRequestSuccessAction = getOptionsRequestSuccessAction;
exports.getOptionsRequestFailAction = getOptionsRequestFailAction;
exports.getOptionsRequestAction = getOptionsRequestAction;
exports.removeUserRequestSuccessAction = removeUserRequestSuccessAction;
exports.removeUserRequestFailAction = removeUserRequestFailAction;
exports.removeUserRequestAction = removeUserRequestAction;
exports.getUserRequestSuccessAction = getUserRequestSuccessAction;
exports.getUserRequestFailAction = getUserRequestFailAction;
exports.getUserRequestAction = getUserRequestAction;
exports.getUsersRequestSuccessAction = getUsersRequestSuccessAction;
exports.getUsersRequestFailAction = getUsersRequestFailAction;
exports.getUsersRequestAction = getUsersRequestAction;
exports.createUserRequestAction = createUserRequestAction;
exports.setPreloadingProcess = setPreloadingProcess;
exports.resetStateAction = resetStateAction;

var selectInProcess = function selectInProcess(state) {
  return state[REDUCER_NAME]['inProcess'];
};

exports.selectInProcess = selectInProcess;

var selectUser = function selectUser(state) {
  return state[REDUCER_NAME]['user'];
};

exports.selectUser = selectUser;

var selectUsers = function selectUsers(state) {
  return state[REDUCER_NAME]['users'];
};

exports.selectUsers = selectUsers;

var selectError = function selectError(state) {
  return state[REDUCER_NAME]['error'];
};

exports.selectError = selectError;

var selectPreloadingProcess = function selectPreloadingProcess(state) {
  return state[REDUCER_NAME]['preloadingProcess'];
};

exports.selectPreloadingProcess = selectPreloadingProcess;

var selectIdentificationData = function selectIdentificationData(state) {
  return state[REDUCER_NAME]['identification'];
};

exports.selectIdentificationData = selectIdentificationData;

var selectIdentificationInProcess = function selectIdentificationInProcess(state) {
  return state[REDUCER_NAME]['identificationInProcess'];
};

exports.selectIdentificationInProcess = selectIdentificationInProcess;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;